import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useCreateSellLogic from '../../../../../../../../../../utils/hooks/sells/orders/useCreateSellLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import { CustomerPayload } from '../../../../../../../../../../utils/reducers/customers/customer'
import { getUserPermissions, getSelectedWorkingCenter } from '../../../../../../../../../../utils/reducers/getters'
import locations from '../../../../../../../../../../utils/globals/locations'
import { BillingGroupPayload } from '../../../../../../../../../../utils/reducers/company/billingGroups'
import { SellModelTypeExtended } from '../../../../headers/types'


interface ModalSellInvoiceDuplicateProps extends ModalEditComponentProps {}

const ModalSellInvoiceDuplicate: React.FC<ModalSellInvoiceDuplicateProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsCustomer = getUserPermissions('customer.profile.main')
    if (!permissionCheck(userPermissionsCustomer, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                {t('newInvoice', 'Nueva factura')}
            </h2>
            <CustomError textError={t('noPermissionsToSeeCustomers', 'No tienes permisos para ver los clientes')} />
        </ModalLittle>
    }
    return (
        <ModalSellInvoiceDuplicateConnect setOpened={setOpened} {...rest} />
    )
}

type ModalSellInvoiceDuplicateAfterPermissionsProps = ModalEditComponentProps & ReduxModalSellInvoiceDuplicateConnector & {}

const ModalSellInvoiceDuplicateAfterPermissions: React.FC<ModalSellInvoiceDuplicateAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, customers, ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { customerInfo, createSell, extraBillingTypesSell, parseBTOBeforeSubmit, addressFields, myCustomerInfo } = useCreateSellLogic({ customers, baseURL: locations.sellInvoiceSingle, BillingGroupId: workingCenter?.BillingGroupId })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<SellModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...customerInfo,
                ...myCustomerInfo,
                ...extraBillingTypesSell,
                {
                    name: 'updatePrice',
                    label: t('updatePricesOfProducts', 'Actualizar precios de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'updateCopyProduct',
                    label: t('updateNameAndDescriptions', 'Actualizar nombre y descripción de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'copyNotes',
                    label: t('copyNotes', 'Copiar notas'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'OrderId',
                    component: 'InputHidden',
                    value: allRowData?.header?.id
                }
            ],
        },
        ...addressFields,
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/sell/sellInvoice/createSellInvoice'} translations={{
            title: t('newInvoice', 'Nueva factura'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error} beforeSubmit={parseBTOBeforeSubmit} {...{ ...rest, onSubmit: createSell }}>
            {error ? <CustomError textError={error} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalSellInvoiceDuplicateDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalSellInvoiceDuplicateConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, customers: state.customers, billingGroups: state.billingGroups })
const modalSellInvoiceDuplicateConnector = connect(mapModalSellInvoiceDuplicateConnector, modalSellInvoiceDuplicateDispatch)
type ReduxModalSellInvoiceDuplicateConnector = ConnectedProps<typeof modalSellInvoiceDuplicateConnector>

const modalSellInvoiceDuplicateConnectLoading = withLoading(ModalSellInvoiceDuplicateAfterPermissions, [{ fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups', params: { includeRelations: true } }])
const ModalSellInvoiceDuplicateConnect = modalSellInvoiceDuplicateConnector(modalSellInvoiceDuplicateConnectLoading)

export default ModalSellInvoiceDuplicate